























































































import { AppConstants, Models } from "@/core/Export";
import store from "@/store";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  components: {}
})
export default class EmployeeAttendEditDayLine extends Vue {
  @Prop() props: object;
  @Prop() onAddPairForDay: Function;
  permissions: any;
  notSignReasonsLocal: any;
  attendSpecialEventsLocal: any;

  constructor() {
    super();
    this.permissions = AppConstants.Permissions;
    this.notSignReasonsLocal = this.notSignReasons;
    this.attendSpecialEventsLocal = this.attendSpecialEvents;
  }

  created() { }

  getRedFrameForMonthlyOrHourly(line: Models.EAME_PairDto, isEntry: boolean) {
    let teken = line.stdTime;
    let time = "";

    if (isEntry) {
      time = line.entryLog.timeText;
    } else {
      time = line.exitLog.timeText;
    }

    let recordDate = Date.parse(line.date);
    let todayDate = Date.parse(
      new Date(new Date().setHours(0, 0, 0, 0)).toISOString()
    );

    if (teken > 0 && todayDate > recordDate) {
      switch (this.currentEmployee.empEmploymentTypeCode) {
        case AppConstants.EmpEmploymentType.Monthly:
          return !time && line.missingEventId == 0 ? "negative" : "";
          break;
        case AppConstants.EmpEmploymentType.Hourly:
          return !time &&
            ((line.entryLog.timeText && !line.exitLog.timeText) ||
              (!line.entryLog.timeText && line.exitLog.timeText)) &&
            line.missingEventId == 0
            ? "negative"
            : "";
          break;
      }
    }
  }

  get currentEmployee() {
    return store.getters.currentEmployee;
  }

  onFiterNotSignReasons(val, update, abort) {
    update(() => {
      const needle = val.toLowerCase()
      this.notSignReasonsLocal = this.notSignReasons.filter(v => v.name.includes(needle))
    })
  }

  onFiterAttendSpecialEvents(val, update, abort) {
    update(() => {
      const needle = val.toLowerCase()
      this.attendSpecialEventsLocal = this.attendSpecialEvents.filter(v => v.name.includes(needle))
    })
  }

  onEntryTimeChanged(e) {
    this.props["row"].entryLog.timeText = Models.AppUtils.formatTime(e.target.value);
    this.appEnv.onResetIsFillTeken(this.props["row"], this.props["row"].pairs, this.props["row"], this.attendSpecialEventsLocal);
  }

  onExitTimeChanged(e) {
    this.props["row"].exitLog.timeText = Models.AppUtils.formatTime(e.target.value);
    this.appEnv.onResetIsFillTeken(this.props["row"], this.props["row"].pairs, this.props["row"], this.attendSpecialEventsLocal);
  }

  onAttendSpecialEventIdChanged(e) {
    this.appEnv.onResetIsFillTeken(this.props["row"], this.props["row"].pairs, this.props["row"], this.attendSpecialEventsLocal);
  }

  getMissingEventName(missingEventId) {
    if (missingEventId > 0) {
      let missingEvent = this.missingEvents.find(s => s.id == missingEventId);
      if (missingEvent) {
        return missingEvent.name;
      }
    } else {
      return;
    }
  }

  getSpecialEventName(specialEventId) {
    if (specialEventId > 0) {
      let specialEvent = this.attendSpecialEvents.find(
        s => s.id == specialEventId
      );
      if (specialEvent) {
        return specialEvent.name;
      }
    } else {
      return;
    }
  }

  getNotSingingReasonName(notSingingReasonId) {
    if (notSingingReasonId > 0) {
      let notSingingReason = this.notSignReasons.find(
        s => s.id == notSingingReasonId
      );
      if (notSingingReason) {
        return notSingingReason.name;
      }
    } else {
      return;
    }
  }

  get notSignReasons() {
    return this.baseItems[AppConstants.BaseItems.NotSingingReason];
  }

  get attendSpecialEvents() {
    return this.employeeAttendEditData.attendSpecialEvents;
  }

  get employeeAttendEditData() {
    return store.getters.employeeAttendEditData;
  }

  get missingEvents() {
    return this.baseItems[AppConstants.BaseItems.MissingEvent];
  }

  get baseItems() {
    return store.getters.baseItems;
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
